// services/PharmacyApiService.js

const API_BASE_URL = 'https://e01.yeapps.com/medi360';

const PharmacyApiService = {
  async fetchPharmacies() {
    try {
      const response = await fetch(`${API_BASE_URL}/data`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.status === 'success') {
        // Transform the client_list data to pharmacy format with proper fields
        return data.client_list.map(client => ({
          id: client.client_id,  // This will be used as customer_id
          name: client.name, // This will be used as customer_name
          address: client.address,
          district: client.district,
          thana: client.thana,
          coordinates: {
            lat: parseFloat(client.latitude),
            lng: parseFloat(client.longitude)
          },
          logo: '/image/Ph01.jpg',
        }));
      } else {
        throw new Error(data.message || 'Failed to fetch pharmacy data');
      }
    } catch (error) {
      console.error('Error in fetchPharmacies:', error);
      throw error;
    }
  },

  async fetchDistricts() {
    try {
      const response = await fetch(`${API_BASE_URL}/get_districts`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const data = await response.json();
      return data.districts || [];
    } catch (error) {
      console.error('Error in fetchDistricts:', error);
      throw error;
    }
  },

  async fetchThanas(district) {
    try {
      const response = await fetch(`${API_BASE_URL}/get_thanas/${encodeURIComponent(district)}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const data = await response.json();
      return data.thanas || [];
    } catch (error) {
      console.error('Error in fetchThanas:', error);
      throw error;
    }
  },

  async fetchPharmaciesByLocation(district, thana) {
    try {
      const response = await fetch(`${API_BASE_URL}/get_pharmacies/${encodeURIComponent(district)}/${encodeURIComponent(thana)}`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.pharmacies) {
        // Transform the pharmacies data to match our format
        return data.pharmacies.map(client => ({
          id: client.client_id,
          name: client.name,
          address: client.address,
          district: client.district,
          thana: client.thana,
          coordinates: {
            lat: parseFloat(client.latitude),
            lng: parseFloat(client.longitude)
          },
          logo: '/image/Ph01.jpg',
        }));
      } else {
        throw new Error(data.error || 'Failed to fetch pharmacies by location');
      }
    } catch (error) {
      console.error('Error in fetchPharmaciesByLocation:', error);
      throw error;
    }
  },
  
  async fetchMedicines() {
    try {
      const response = await fetch(`${API_BASE_URL}/medicine_list`);
      
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      
      const data = await response.json();
      
      if (data.status === 'success') {
        return data.medicine_list;
      } else {
        throw new Error(data.message || 'Failed to fetch medicine data');
      }
    } catch (error) {
      console.error('Error in fetchMedicines:', error);
      throw error;
    }
  },
  
  async placeOrder(orderData) {
    try {
      const response = await fetch(`${API_BASE_URL}/orders`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(orderData)
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || `Server responded with status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error in placeOrder:', error);
      throw error;
    }
  }
};

export default PharmacyApiService;